import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

/**
 * The button row every create and edit screen ends with.
 *
 * Two different shapes, because the two contexts are different. On a desktop it
 * is a sticky row at the foot of the card, buttons right-aligned at their
 * natural size. On a phone it is pinned above the navigation bar with
 * full-width buttons -- matching the create sheets, which is the layout that
 * works there.
 *
 * bottom-14 is the height of MobileNavigation. Without it the row sat at
 * bottom-0 and the navigation covered it, so Save was unreachable on any form
 * long enough to scroll -- which was every one of them.
 */
export const FormToolbar = () => (
  <div
    role="toolbar"
    className="
      sticky bottom-14 sm:bottom-0 z-10
      -mx-6 sm:mx-0 mt-4 px-6 sm:px-0 py-3 sm:pt-3 sm:pb-2
      border-t bg-card
      flex flex-row-reverse sm:flex-row justify-start sm:justify-end gap-2
      [&>button]:flex-1 sm:[&>button]:flex-none
      [&>button]:h-11 sm:[&>button]:h-9
    "
  >
    {/* Reversed on mobile so Save lands under the thumb on the right, the way
        it does in the create sheets. */}
    <SaveButton />
    <CancelButton />
  </div>
);
